import { createFeatureSelector, createSelector } from "@ngrx/store";
import { FaqState } from "./faq.reducer";

export const selectFaqState = createFeatureSelector<FaqState>('faq');

export const selectAllFaqs = createSelector(
  selectFaqState,
  (state: FaqState) => state.faqs
);
